<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center vx-card">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-1/3 sm:m-0 m-4">
      
        <form @submit.prevent="onSubmit">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col w-full">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4" style="text-align: center;">
                      Nitro Dashboard
                    </h4>
                    <p style="text-align: center;">
                      Şifre sıfırlamak için e-posta adresinizi giriniz.
                    </p>
                  </div>
                  <vs-input name="userMail" icon="icon icon-user" icon-pack="feather" class="w-full" label-placeholder="Email adresinizi giriniz." icon-no-border v-validate="'email'" type="email" v-model="email" />
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>

                  <div v-if="!submitClicked">
                    <vs-button class="float-right mt-5">Gönder</vs-button>
                  </div>
                  <div v-else-if="submitClicked">
                    <p style="text-align: right; margin-top: 16px; font-weight: bolder;">
                      Mail gönderimi yapılmıştır. Inboxınızı kontrol ediniz.
                    </p>
                  </div>
                  <vs-divider>www.nitrobilisim.com.tr</vs-divider>
                  <vue-recaptcha sitekey="6Le0WMEZAAAAAOLZVy6LzXyWAaP4JpmYpQwmdElQ"></vue-recaptcha>

                  <vs-alert v-show="ErrorShow" title="Uyarı" color="danger"> Şifre Onayı hatalı</vs-alert>
                </div>
              </div>
            </div>
          </div>
        </form>
      
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { Validator } from "vee-validate";
import { authenticationService } from "../../_services/authentication.service";

const dict = {
  custom: {
    email: {
      email: "Email adresi ornek@ornek.com şeklinde olmalıdır!",
    },
  },
};
export default {
  components: { VueRecaptcha },

  data() {
    return {
      ErrorShow: false,
      email: "",
      submitClicked: false,
    };
  },
  created() {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    onSubmit: async function() {
      if (this.errors.any()) {
        return;
      }

      this.$vs.loading();

      await authenticationService
        .recover(this.email)
        .catch((e) => {
          console.warn("login error", e);
          this.ErrorShow = true;
        })
        .then(() => {
          this.submitClicked = true;
        });
      this.$vs.loading.close();
    },
  },
};
</script>
